<template>
  <div class="change-details-dialog">
    <el-dialog
      :title="title"
      :visible.sync="openChangeDetailsDialog"
      top="4%"
      width="800px"
      :before-close="closeDialog">
      <m-pane
          ref="tablePage"
          class="tablePage"
          :config="config"
          :totalData="tableData"
          :pageTotal="pageTotal"
          :loading="loading"
          :currentPage="currentPage"
          @pageChange="pageChange"
          @sizeChange="sizeChange"
          @selectChange="selectChange"
        ></m-pane>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mPane from '../../../../../../components/Table/Index.vue';
import { getDetailsData } from '../../../../../../api/changeDetails.js';
import config from './dialogConfig.json';
export default {
    name: 'change-details-dialog',
    components: { mPane },
    props: {
        openChangeDetailsDialog: {
            type: Boolean,
            default() {
                return false;
            }
        },
        title: {
            type: String,
            default() {
                return '';
            }
        },
        changeApplyNo: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            tableData: [],
            dictData: {},
            config,
            pageTotal: 0, // 总条数
            loading: false, // table的loading状态
            currentPage: 1, // 当前页数
            searchParams: {
                pageSize: 10,
                pageNo: 1
            }
        };
    },
    methods: {
        closeDialog() {
            this.$emit('update:openChangeDetailsDialog', false);
        },
        handleDetails() {
            getDetailsData({ changeApplyNo: this.changeApplyNo }).then(res => {
                if (res && res.code === '0') {
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
            });
        },
        selectChange(data) {
            this.selected = [].concat(data);
        },
        pageChange(data) {
            this.searchParams.pageNo = data;
            this.handleDetails();
        },
        sizeChange(data) {
            this.searchParams.pageSize = data;
            this.handleDetails();
        }
    },
    mounted() {
        this.handleDetails();
    }
};
</script>
<style lang="less">
</style>